import React from "react";

import Background from "../../../assets/lunch/lunch-bg-01.png";

import GamePageLayout from "../GamePageLayout";

const LunchPage1 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      onClickNext={() => setCurrentPage("lunch-2")}
    >
      오늘 금요일이라 그런지
      <br />
      시간이 빨리 가네.
      <br />
      벌써 점심시간이야.
      <br />
      오늘 점심 뭐 먹지?
    </GamePageLayout>
  );
};

export default LunchPage1;
